import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for Confluence whiteboard diagramming.
 */
type ConfluenceWhiteboardDiagrammingData = {
	/**
	 * The diagramming response.
	 */
	content: string;
	/**
	 * The type of diagramming (MINDMAP, FLOW_CHART, etc.)
	 */
	diagramType: string;
	/**
	 * The content ID of the whiteboard.
	 */
	contentId: string;
};

/**
 * Properties for the Confluence whiteboard diagramming command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceWhiteboardDiagrammingCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the whiteboard diagramming request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the whiteboard diagramming.
	 */
	data: ConfluenceWhiteboardDiagrammingData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
	/**
	 * The status of the whiteboard brainstorming.
	 */
	status: 'STREAMING' | 'SUCCESS';
}
/**
 * A command sent by a bridge API client to start a Confluence whiteboard diagramming.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to start a Confluence whiteboard diagramming.
 */
export const ConfluenceWhiteboardDiagrammingCommand =
	createCommand<ConfluenceWhiteboardDiagrammingCommandProperties>(
		'confluence-whiteboard-diagramming-command',
	);
